import { Typography, Modal } from '@mui/material'

import { Button } from '../../components/Button/Button'

import './AboutAppModal.scss'

export const AboutAppModal = ({
  open,
  setOpen
}: {
  open: boolean
  setOpen: any
}) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <div className="main-div-about-app-modal">
        <Typography variant="h5">About</Typography>
        <Typography className="about-text" variant="body2">
          Muffin is a social timer app that allows you to work together with
          your friends or team members. <br />
          <br />
          It uses a flexible Pomodoro timer, allowing you to work and break in
          chunks. This method is psychologically proven to increase
          productivity.
          <br />
          <br /> While working, you can use the Chat tab to talk to other people
          in the room, and the Checklist tab to organize your tasks, and share
          them with others for teamwork or accountability. <br />
          <br />
          During your break, you can play high score games with your friends.
          Enjoy working!
        </Typography>
        <Button label="Ok" onClick={() => setOpen(false)} />
      </div>
    </Modal>
  )
}
